import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

const SidebarMenu = ({ route, isOpen, setIsOpen }) => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Check if any subRoute matches the current URL to keep it open
  useEffect(() => {
    if (route.subRoutes) {
      const isPathActive = route.subRoutes.some((subRoute) => {
        const basePath = subRoute.path.split('?')[0];
        return location.pathname.includes(basePath);
      });
      if (isPathActive) {
        setIsMenuOpen(true);
      }
    }
  }, [location.pathname, route.subRoutes]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsOpen(true);
  };

  useEffect(() => {
    if (!isOpen) {
      setIsMenuOpen(false);
    }
  }, [isOpen]);
  
  return (
    <>
      <div className="menu" style={{ cursor: 'pointer' }} onClick={toggleMenu}>
        <div className="menu_item">
          <div className="icon">{route.icon}</div>
          <div className="link_text" style={{ display: isOpen ? "block" : "none" }}>
            {route.name}
          </div>
        </div>
        {isOpen && (
          <div style={{ transition: "transform 0.2s ease", transform: isMenuOpen ? "rotate(90deg)" : "rotate(0)" }}>
            <i className="fa-solid fa-angle-right" style={{ fontSize: '12px' }}></i>
          </div>
        )}
      </div>
      
      {/* Sub menu container */}
      <div 
        className="menu_container"
        style={{
          maxHeight: isMenuOpen ? "500px" : "0",
          overflow: "hidden",
          transition: "max-height 0.3s ease",
          opacity: isMenuOpen ? 1 : 0
        }}
      >
        {route.subRoutes.map((subRoute, i) => (
          <NavLink to={subRoute.path} className="link" key={i}>
            <div className="icon" style={{ fontSize: '10px' }}><i className="fa-solid fa-circle"></i></div>
            <div className="link_text" style={{ display: isOpen ? "block" : "none" }}>
              {subRoute.name}
            </div>
          </NavLink>
        ))}
      </div>
    </>
  );
};

export default SidebarMenu;
